module.exports = __webpack_public_path__ + "img/PR5.55889e70.gif";